"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Offer() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const portraits = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roof_inspection_close.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roof_inspection_close.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roof_inspection_close.png-wvc-sizes",
    alt: "Professional roof inspection in progress"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/residential_roof_repair.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/residential_roof_repair.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/residential_roof_repair.png-wvc-sizes",
    alt: "Residential roof repair by expert team"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/cash_home_buying_deal.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/cash_home_buying_deal.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/cash_home_buying_deal.webp-wvc-sizes",
    alt: "Fast cash home buying transaction"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/storm_damage_assessment.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/storm_damage_assessment.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/storm_damage_assessment.png-wvc-sizes",
    alt: "Storm damage assessment on residential property"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/commercial_roofing_project.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/commercial_roofing_project.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/commercial_roofing_project.png-wvc-sizes",
    alt: "Large scale commercial roofing project"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/fast_closing_home.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/fast_closing_home.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/fast_closing_home.png-wvc-sizes",
    alt: "Modern home ready for fast cash sale"
  }];
  return <section data-section-id="760" id="get-a-fair-cash-offer-in-minutes" className="dark bg-background text-foreground relative min-h-[90vh] w-full overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-10 md:py-24 lg:px-14 lg:py-0 lg:min-h-[90vh] lg:flex lg:items-center">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-12 w-full">
          {}
          <div ref={leftRef} className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="font-mono text-[11px] tracking-[0.25em] uppercase mb-10" style={{
            color: "var(--primary)"
          }}>
              <span style={{
              color: "var(--primary)"
            }}>Solutions</span>
              <span className="mx-2 text-muted-foreground">/</span>
              <span className="text-foreground">2025</span>
            </div>

            {}
            <h1 className="font-default font-bold text-foreground leading-[0.95] text-[44px] sm:text-[56px] md:text-[68px] lg:text-[72px] xl:text-[80px]" style={{
            letterSpacing: "-0.03em"
          }}>
              Fair Cash
              <br />
              Offers in
              <br />
              Minutes
            </h1>

            {}
            <Separator className="my-10 bg-border" style={{
            width: "64px",
            height: "1px"
          }} />

            {}
            <p className="font-default text-[17px] leading-[1.65] text-muted-foreground max-w-[480px]">
              Luxury Construction LLC provides professional roofing services and 
              nationwide cash home buying solutions. Whether you need a roof 
              repair or want to sell your house as-is, we deliver fast, 
              hassle-free results with exceptional customer service.
            </p>

            {}
            <div className="mt-12 font-mono text-[12px] tracking-[0.2em] uppercase text-muted-foreground">
              <span className="text-foreground">Nationwide</span>
              <span className="mx-3" style={{
              color: "var(--primary)"
            }}>
                /
              </span>
              <span className="text-foreground">Fast Closings</span>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-7 flex items-center transition-all duration-1200 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="grid w-full grid-cols-2 grid-rows-3 gap-2 lg:grid-cols-3 lg:grid-rows-2 lg:aspect-[3/2.1]">
              {portraits.map((portrait, i) => <div data-index={i} key={i} className="relative overflow-hidden bg-muted group" style={{
              transitionDelay: `${i * 80}ms`
            }}>
                  <img src={portrait.src} data-wvc-srcset={portrait.srcset} data-wvc-sizes={portrait.sizes} alt={portrait.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105" style={{
                filter: "grayscale(0.2) contrast(1.1) brightness(0.95)",
                aspectRatio: "1 / 1"
              }} />
                  {}
                  <div className="pointer-events-none absolute inset-0 mix-blend-multiply opacity-40" style={{
                background: "linear-gradient(135deg, hsla(45, 90%, 45%, 0.25), hsla(220, 15%, 6%, 0.45))"
              }} />
                  {}
                  <div className="absolute top-2 left-2 font-mono text-[10px] tracking-[0.2em] text-foreground/70 mix-blend-difference">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0">
        <Separator className="bg-border/60" />
      </div>
    </section>;
}